import { createSlice, createSelector } from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { selectProjectCategories } from 'state/Organization/organizationSlice';

interface CategoriesState {
  selectedCategoryIds?: string[];
}

const initialState: CategoriesState = {};

const categoriesSlice = createSlice({
  name: 'projectsList/filters/categories',
  initialState,
  reducers: {
    setSelectedCategoryIds: (state, action) => {
      state.selectedCategoryIds = action.payload;
    },
  },
});

const getCategoriesState = (state: RootState) =>
  state.projectsList.filters.categories;

export const { setSelectedCategoryIds } = categoriesSlice.actions;

export const selectSelectedCategoryIds = createSelector(
  [getCategoriesState],
  (categoriesState) => categoriesState.selectedCategoryIds
);

export const selectSelectedProjectCategories = createSelector(
  [selectProjectCategories, selectSelectedCategoryIds],
  (categories, selectedCategoryIds) =>
    categories.filter((category) => selectedCategoryIds?.includes(category.id))
);

export default categoriesSlice.reducer;
